// Simple cookie helpers for storing hidden messages
export const getCookie = (name) => {
  if (typeof document === 'undefined') return null
  const v = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')
  return v ? decodeURIComponent(v.pop()) : null
}

export const setCookie = (name, value, days) => {
  if (typeof document === 'undefined') return
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = `${name}=${encodeURIComponent(value || '')}${expires}; path=/`
}

const HIDDEN_MESSAGES_COOKIE = 'htc-hidden-messages-1'

export const getHiddenMessages = () => {
  try {
    const v = getCookie(HIDDEN_MESSAGES_COOKIE)
    if (!v) return []
    const parsed = JSON.parse(v)
    if (!Array.isArray(parsed)) return []
    // Normalize to array of objects: { id, updatedAt }
    return parsed
      .map((p) => {
        if (p === null || typeof p === 'undefined') return null
        if (typeof p === 'string' || typeof p === 'number') return { id: p, updatedAt: null }
        if (typeof p === 'object' && p.id) return { id: p.id, updatedAt: p.updatedAt ?? null }
        return null
      })
      .filter(Boolean)
  } catch (e) {
    return []
  }
}

export const clearHiddenMessages = () => {
  setCookie(HIDDEN_MESSAGES_COOKIE, '', -1)
}

export const hideMessageId = (id, updatedAt = null, days = 365) => {
  try {
    if (!id) return

    // Back-compat: if caller passed days as second argument (number), shift params
    if (typeof updatedAt === 'number') {
      days = updatedAt
      updatedAt = null
    }

    const arr = getHiddenMessages()
    const entry = { id, updatedAt: updatedAt ? new Date(updatedAt).toISOString() : new Date().toISOString() }
    const i = arr.findIndex((e) => e && e.id === id)
    if (i === -1) {
      arr.push(entry)
    } else {
      arr.splice(i, 1, entry)
    }
    setCookie(HIDDEN_MESSAGES_COOKIE, JSON.stringify(arr), days)
  } catch (e) {
    // noop
  }
}

export default {
  getCookie,
  setCookie,
  getHiddenMessages,
  hideMessageId,
}
